import { useEffect, useState } from "react";
import { axiosClient } from "../services/axiosClient";
import logToGoogleSheet from '../utils/SendLogs';

const claimVisits = async (useruid,setMessage,setOpenSnackBar,t) => {
  const pointsToclaim = 25;
  try {
    return await axiosClient.post(`${process.env.REACT_APP_SERVER_URL}/appcredits/visitsclaim/${useruid}`,{pointsToclaim:pointsToclaim})


    //setError("");  
  } catch (err) {  
    //setError(err.response?.data?.message || "An error occurred.");  
    console.log(err.response?.data?.message || "An error occurred.")
    setMessage({body:t("alerts.app_credits_already_visits_claim"),severity:'info'})
    setOpenSnackBar(true)
  }  
};
// Pi Ads logic 
 export default function usePiAds({t,setMessage,setOpenSnackBar,setAppcredits, setNextClaimAvailable, setOpenmedalmodal,setShowProgress}) {

      const [isAdNetworkSupported, setIsAdNetworkSupported] = useState(localStorage.getItem('adNetworkSupported') ? localStorage.getItem('adNetworkSupported') : false);
      
      useEffect(() => {
        const initPiAds = async () => {
          if (window.Pi && typeof window.Pi.init === 'function') {
            const nativeFeaturesList = await window.Pi.nativeFeaturesList();
            const adNetworkSupported = nativeFeaturesList.includes("ad_network");
            localStorage.setItem('adNetworkSupported', adNetworkSupported);
            logToGoogleSheet(`adNetworkSupported : ${adNetworkSupported}`)
            setIsAdNetworkSupported(adNetworkSupported);
          }
        };
        initPiAds();
      }, []);

      const showPiAds = async () => {
        if (window.Pi && typeof window.Pi.init === 'function') {
          if (!isAdNetworkSupported) {
            console.warn("Ad network is not supported by the Pi SDK.");
            return;
          }else{
           // setShowProgress(true);
         
          }
        const ready = await window.Pi.Ads.isAdReady("interstitial");

        if (!ready) {
          console.warn("Interstitial ad is not ready.");
          return;
        }
          const requestAdResponse = await window.Pi.Ads.requestAd("interstitial");
         
         if (requestAdResponse.result !== "AD_LOADED") {
            showPiAds();
           // indicate to user that ad could not be loaded
          return;
          }
        const showAdResponse = await window.Pi.Ads.showAd("interstitial");
                          console.log("response : ", showAdResponse);
                         
              logToGoogleSheet(`piAds showResponse : ${JSON.stringify(showAdResponse)}`);
              const verifyAdResponse = await axiosClient.post(`${process.env.REACT_APP_SERVER_URL}/piads/verifyAdId/${showAdResponse.adId}`);

              if (verifyAdResponse.data.mediator_ack_status === "granted") {
                logToGoogleSheet(`piAds verifyAdResponse : ${JSON.stringify(verifyAdResponse.data)}`);
                console.log("Ad display verified and acknowledged by mediator.");
              }

            if (showAdResponse.result === "AD_CLOSED") {
              // indicate to user that ad could not be displayed
              setShowProgress(false);
              console.log("Ad closed");
               return;
         }
        }
      };

      const showRewardedPiAds = async (useruid) => {
       if (window.Pi && typeof window.Pi.init === 'function') {

     try {
      const ready = await window.Pi.Ads.isAdReady("rewarded"); 
        if (ready === false) { 
        const requestAdResponse = await window.Pi.Ads.requestAd("rewarded"); 
        if (requestAdResponse === "ADS_NOT_SUPPORTED") { 
        // display modal to update Pi Browser 
        // showAdsNotSupportedModal() 
        return; 
        } 
        if (requestAdResponse !== "AD_LOADED") { 
        // display modal ads are temporarily unavailable and user should try again later 
        // showAdUnavailableModal() 
        return; 
        } 
        } 
        const showAdResponse = await window.Pi.Ads.showAd("rewarded"); 
        if (showAdResponse.result === "AD_REWARDED") { 
         // logToGoogleSheet(`showAdResponse  : ${JSON.stringify(showAdResponse)}`);
          logToGoogleSheet(`Rewarded Ad Id : ${JSON.stringify(showAdResponse.adId)}`);   
        // reward user logic, usually delegate rewarding user to your backend which would 
        // firstly verify `adId` against Pi Platform API, then decide whether to reward the user 
        // and rewarded user if the rewarded ad status is confirmed 
         const verifyAdResponse = await axiosClient.post(`${process.env.REACT_APP_SERVER_URL}/piads/verifyAdId/${showAdResponse.adId}`);
           //alert("piAds verifyAdResponse : "+JSON.stringify(verifyAdResponse));
           logToGoogleSheet(`piAds rewarded verifyAdResponse : ${JSON.stringify(verifyAdResponse)}`);

          // if (/* showAdResponse.result === "AD_REWARDED" && */ verifyAdResponse.data.adStatus.mediator_ack_status === "granted") {
  
          
          try {
            await claimVisits(useruid,setMessage,setOpenSnackBar,t).then((response) => {
              console.log(response);
              if (response !== undefined) {
                setAppcredits(response.data.appcredits);
                setNextClaimAvailable(new Date(response.data.nextClaimAvailable));
                setOpenmedalmodal(true);
              }
            });
          } catch (err) {
            console.log(err);
          }
        }
       // } else { 
        // fallback logic 
        // showAdErrorModal() 
       // } 
        } catch (err) { 
        // good practice to handle any potential errors 
        } 
        };
      }
        
        return { isAdNetworkSupported, showPiAds, showRewardedPiAds };
  }